import React, { useEffect, useState } from "react";
import styles from "../mobilesignup2style.module.css";
import { Button } from "@mui/material";

const ChoiceValue: React.FC<any> = (props) => {

    const [imgLoaded, setImgLoaded] = useState(false);

    const handleClick = (value: string) => {
        props.setValue(value);
        props.setPage(2);
    }


    return (
        <div className={styles.mainContainer} 
        style={{
            height : props.bodyHeight ? `${props.bodyHeight}px` : "auto",
            overflowY : "auto",
            //스크롤 숨기기
            scrollbarWidth : "none" as any,
            msOverflowStyle : "none" as any
        }}
        >
            <div style={{
                color: "#202632",
                fontFamily: "Apple_B",
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                marginTop: "5px"
            }}>
                학생, 학부모, 직원 중<br />선택해주세요
            </div>
            <div style={{
                marginTop: "14px",
                fontFamily: "Apple_R",
                lineHeight: "22px",
                fontWeight: 500
            }}>
                수능선배 학원 등록을 위해서는<br />회원가입이 필수입니다.
            </div>

            <div style={{
                marginTop: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems : "flex-end"
            }}>
                <div style={{
                    width: "75%",
                    aspectRatio: "281.297 / 372.266",
                    display : "flex",
                    alignItems : "flex-end"
                }}>
                    {/* {!imgLoaded && (
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                borderRadius: "12px",
                                backgroundColor: "#f3f3f3",
                            }}
                        />
                    )} */}
                    <img
                        src="/img/appdashboard.webp"
                        alt="signupillustration"
                        onLoad={() => setImgLoaded(true)}
                        onError={() => setImgLoaded(true)}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            opacity: imgLoaded ? 1 : 0,
                        }}
                    />
                </div>
            </div>

            <div style={{
                paddingBottom : "20px",
            }}>
                <div>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#3182f6",
                            height: "52px",
                            borderRadius: "13px",
                            fontWeight: 500,
                            fontFamily: "Apple_R",
                            boxShadow: "none !important",
                            '&.Mui-disabled': {
                                backgroundColor: '#C1d6f3',
                                color: "white"
                            },
                            "&:hover": {
                                backgroundColor: "#3182f6",
                                boxShadow: "none",
                            },

                            "&:active": {
                                backgroundColor: "#3182f6",
                            },

                            "&.Mui-focusVisible": {
                                backgroundColor: "#3182f6",
                            }
                        }}
                        fullWidth
                        onClick={() => handleClick("student")}
                    >
                        학생으로 가입하기
                    </Button>
                </div>
                <div style={{
                    marginTop: "10px"
                }}>
                    <Button
                        variant="contained"
                        sx={{
                            height: "52px",
                            borderRadius: "13px",
                            fontWeight: 500,
                            fontFamily: "Apple_R",
                            marginTop: "2px",
                            boxShadow: "none !important",
                            color: "white",
                            backgroundColor: "#202632",
                            "&:hover": {
                                backgroundColor: "#202632",
                                boxShadow: "none",
                            },

                            "&:active": {
                                backgroundColor: "#202632",
                            },

                            "&.Mui-focusVisible": {
                                backgroundColor: "#202632",
                            },
                        }}
                        fullWidth
                        onClick={() => handleClick("parent")}
                    >
                        학부모로 가입하기
                    </Button>
                </div>
                <div style={{
                    marginTop: "10px"
                }}>
                    <Button
                        variant="contained"
                        sx={{
                            height: "52px",
                            borderRadius: "13px",
                            fontWeight: 500,
                            fontFamily: "Apple_R",
                            marginTop: "2px",
                            boxShadow: "none !important",
                            color: "#202632",
                            backgroundColor: "#efefef",
                            "&:hover": {
                                backgroundColor: "#efefef",
                                boxShadow: "none",
                            },

                            "&:active": {
                                backgroundColor: "#efefef",
                            },

                            "&.Mui-focusVisible": {
                                backgroundColor: "#efefef",
                            },
                        }}
                        fullWidth
                        onClick={() => handleClick("teacher")}
                    >
                        직원으로 가입하기
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ChoiceValue;